export let UserPromptType;
(function (UserPromptType) {
  UserPromptType["AGENT_STATUS_WORKING_HOURS"] = "AGENT_STATUS_WORKING_HOURS";
})(UserPromptType || (UserPromptType = {}));